import React from 'react';

import {
  Link,
  Typography
} from '@mui/material';

import { LabelledText } from 'modules/layer00';
import { BaseWidget } from 'modules/layer01';
import * as dataService from './dataService';



export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);

  return (
    <BaseWidget.FC
      title="Return Shipping">
      <LabelledText.FC
        title="Carrier Code"
        text={queryTuple.data.carrierCode} />

      <LabelledText.FC
        title="Tracking Number"
        text={(
          <Link
            href={queryTuple.data.urlToTrackingPage}
            target="_blank">
            {queryTuple.data.trackingNumber}
          </Link>
        )} />

      <LabelledText.FC
        title="Address"
        text={(
          <>
            <Typography>{queryTuple.data.customerName}</Typography>
            <Typography>{queryTuple.data.street1}</Typography>
            <Typography>{queryTuple.data.street2}</Typography>

            <Typography>
              {`${queryTuple.data.city}, ${queryTuple.data.usState}, ${queryTuple.data.postalCode}`}
            </Typography>
          </>
        )} />
    </BaseWidget.FC>
  );
};
